module.exports = __webpack_public_path__ + "img/insurance-logo-9.8cd67167.png";